import { render, staticRenderFns } from "./RemoveBooking.vue?vue&type=template&id=558067ee"
import script from "./RemoveBooking.vue?vue&type=script&lang=js"
export * from "./RemoveBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports